import type { teams as pt } from '../pt/teams';
// English mirror of ../pt/teams.ts (shape checked against its pt twin).
export const teams: typeof pt = {
  // Shared member / team counters (interpolated).
  members: '{n} members',
  memberOne: '1 member',
  teamsCount: '{n} teams',
  teamOne: '1 team',

  list: {
    title: 'Research Teams',
    linesTitle: 'Thematic Lines',
    subtitle: 'Research Teams and Thematic Lines',
    syncedAt: 'synced {date}',
    neverSynced: 'never synced',
    sync: 'Sync',
    syncing: 'Syncing…',
    syncFailed: 'SISTRADE sync failed: {error}',
    readFailed: 'Could not read from SISTRADE: {error}',
    searchPlaceholder: 'Search by team, thematic line or PI…',
    emptyTeams: 'No research teams.',
    emptyLines: 'No thematic lines.',
    source: {
      rest: 'SISTRADE',
      sql: 'SISTRADE (DB)',
      hybrid: 'SISTRADE',
      stub: 'Demo data',
      none: 'No connection',
    },
  },

  equipa: {
    membersLabel: 'Members',
    piNames: 'PI: {names}',
    copiNames: 'CO-PI: {names}',
    lineBadge: 'Thematic Line',
    noMembers: 'No members in the current data source.',
    lineTeams: 'Research teams in this line',
    noTeams: 'No research teams associated.',
    roleInUnit: 'Role in the FCT Unit',
    dedicationTitle: '% Dedication',
    dedicationText: '{n}% dedication',
    entryTitle: 'Team entry date (SISTRADE)',
    entryText: 'since {date}',
    memberCode: 'Collaborator code (record)',
  },

  myteam: {
    title: 'My Team',
    subtitle:
      'Records you started — the status advances as Onboarding / HR validate and launch them.',
    newRecord: 'New Record',
    records: '{n} records',
    recordOne: '1 record',
    filterByStatus: 'Filter by status',
    allStatuses: 'All statuses',
    empty: 'You have not started any record yet. Use “New Record”.',
    colName: 'Name',
    colEmail: 'Email',
    colStatus: 'Status',
    colReceived: 'Received',
  },
};
